import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Observable } from "rxjs";

import { AuditDto } from "../../../core/api/models/audit-dto";
import { AuditVm } from "../../../core/api/models/audit-vm";
import { BaseIndexPageComponent } from "../base/components/base-index-page.component";

@Component({
    selector: "app-audit",
    templateUrl: "./audit.component.html",
    standalone: false
})
export class AuditComponent extends BaseIndexPageComponent implements OnInit {
  //#region properties

  pageName = "audits";
  modelWithPagination$: Observable<AuditVm>;
  items$: Observable<Array<any>>;

  @Input("service") currentService: Object;
  @Input("methodName") methodName: string;
  @Input("title") title: string = "pages.audits.auditList";
  @Input("sortReferenceId") referenceIdSortAbility: boolean = true;
  @Input("defaultSortColumn") defaultSortColumn: string = "Document.StartDate";
  @Input("hideReferenceId") hideReferenceId: boolean = false;

  @Output() hidePage = new EventEmitter<boolean>();

  showAuditDetails: boolean = false;
  auditDetailsModel: AuditDto;

  //#endregion

  ngOnInit() {
    super.ngOnInit();

    //table config
    this.pageConfig.title = this.title;
    this.pageConfig.isForm = true;
    this.pageConfig.tableConfig.pageSizes = [30, 40, 50, 60, 80, 100];
    //set referenceId SortAbility
    if (!this.hideReferenceId)
      this.tableColumns.find(
        (item) => item.title === `${this.tableVocabs}referenceId`
      ).noSorting = !this.referenceIdSortAbility;
  }

  configTableColumns() {
    this.tableVocabs = this.pageVocabs + "fields.";

    this.tableColumns = [
      {
        title: this.localizer.userName,
        name: "Document.UserInfo.userName",
        hasSearch: true,
        type: "auditText",
        noSorting: true,
      },
      {
        title: `${this.tableVocabs}referenceId`,
        name: "Document.ReferenceId",
        hasSearch: true,
        type: "auditNumber",
      },
      {
        title: `${this.tableVocabs}operationType`,
        name: "Document.OperationType",
        hasSearch: true,
        type: "auditText",
        noSorting: true,
      },
      {
        title: `${this.tableVocabs}comments`,
        name: "Document.Comments",
        hasSearch: true,
        type: "auditText",
        noSorting: true,
      },
      {
        title: this.localizer.startDate,
        name: "Document.StartDate",
        hasSearch: true,
        type: "dateTime",
      },
      {
        title: this.localizer.endDate,
        name: "Document.EndDate",
        hasSearch: true,
        type: "dateTime",
      },
    ];

    if (this.hideReferenceId) this.tableColumns.splice(1, 1);

    //اگر گزارش گیری منوی لیست سیاه بود باید بجای شناسه جدول شماره موبایل را نمایش دهد
    if (this.methodName == "blackListsGetBlackListAudits")
      this.tableColumns.splice(1, 0, {
        title: this.localizer.mobile,
        name: "Document.Target.New.Mobile",
        hasSearch: true,
        type: "auditText",
        dir: "ltr",
      });
  }

  setDefaultTableSort() {
    this.sortObject.push({ columnName: this.defaultSortColumn, sort: 1 });
  }

  //#region init methods

  getPaginationApi(): Observable<AuditVm> {
    return this.currentService[this.methodName]({
      body: this.getBaseModelWithPaginationParams(),
    });
  }

  //#endregion

  //#region operations

  onHidePage() {
    this.showParent = true;
    this.getParentQueryString();
    this.hidePage.emit(true);
  }

  onReset() {
    this.pageConfig.tableConfig.comparisonObjects = [];
    this.pageConfig.tableConfig.sortObject = [];
    this.getTableData();
  }

  onDetail(model: AuditDto) {
    this.auditDetailsModel = model;
    this.showAuditDetails = true;
  }

  onCloseDetail(event) {
    this.showAuditDetails = false;
  }

  //#endregion
}
